import React from "react";
import styled, { keyframes } from "styled-components";
import { getBranchOrderingStatus, isCurrentTimeInSchedule } from "../../../utils";

const slideDown = keyframes`
  from { transform: translateY(-100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const Banner = styled.div<{ $color: "green" | "yellow" | "red" }>`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  font-size: var(--font-size-body-small);
  font-weight: var(--font-weight-regular);
  text-align: center;
  animation: ${slideDown} 0.3s ease;

  ${({ $color }) => {
    switch ($color) {
      case "green":
        return `
          background: var(--color-success-bg);
          color: var(--color-success);
        `;
      case "yellow":
        return `
          background: var(--color-warning-bg);
          color: var(--color-warning);
        `;
      case "red":
        return `
          background: var(--color-error-bg);
          color: var(--color-error);
        `;
    }
  }}
`;

const Dot = styled.span<{ $color: "green" | "yellow" | "red" }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 8px;
  background: ${({ $color }) => {
    switch ($color) {
      case "green": return "var(--color-success)";
      case "yellow": return "var(--color-warning)";
      case "red": return "var(--color-error)";
    }
  }};
`;

interface OnlineOrderingBannerProps {
  branch: {
    isOpen: boolean;
    openingHours?: any;
  };
}

export const OnlineOrderingBanner: React.FC<OnlineOrderingBannerProps> = ({ branch }) => {
  // Admin completely disabled online ordering
  if (!branch.isOpen) {
    return (
      <Banner $color="red">
        <Dot $color="red" />
        Zamawianie online jest chwilowo niedostępne
      </Banner>
    );
  }

  // Check if current time falls within opening hours schedule
  const isWithinSchedule = isCurrentTimeInSchedule(branch.openingHours ?? {});
  const status = getBranchOrderingStatus(isWithinSchedule, branch.openingHours ?? {});

  return (
    <Banner $color={status.color}>
      <Dot $color={status.color} />
      {status.message}
    </Banner>
  );
};
